import styled from 'styled-components';

import InputMask from 'react-input-mask';

export const Input01 = styled.input`
  width: 100%;
  float: left;
  font-size: 1.2rem;
  border: none;
  height: 4rem;
  line-height: 4rem;
  background: none;
  font-weight: 500;
  padding: 0 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.colors.FORM_INPUT_TEXT};

  ::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.FORM_INPUT_PLACEHOLDER};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
`;

export const Input02 = styled(InputMask)`
  width: 100%;
  float: left;
  font-size: 1.2rem;
  border: none;
  height: 4rem;
  line-height: 4rem;
  background: none;
  font-weight: 500;
  padding: 0 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.colors.FORM_INPUT_TEXT};

  ::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.FORM_INPUT_PLACEHOLDER};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
`;
